import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_7714_76822)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_7714_76822"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M1.33594 7.99842L7.76409 11.2125C7.85154 11.2562 7.89527 11.2781 7.94114 11.2867C7.98176 11.2943 8.02345 11.2943 8.06407 11.2867C8.10994 11.2781 8.15366 11.2562 8.24112 11.2125L14.6693 7.99842M1.33594 11.3317L7.76409 14.5458C7.85154 14.5896 7.89527 14.6114 7.94114 14.62C7.98176 14.6276 8.02345 14.6276 8.06407 14.62C8.10994 14.6114 8.15366 14.5896 8.24112 14.5458L14.6693 11.3317M1.33594 4.66508L7.76409 1.45101C7.85154 1.40728 7.89527 1.38541 7.94114 1.37681C7.98176 1.36919 8.02345 1.36919 8.06407 1.37681C8.10994 1.38541 8.15366 1.40728 8.24112 1.45101L14.6693 4.66508L8.24112 7.87916C8.15366 7.92289 8.10994 7.94475 8.06407 7.95335C8.02345 7.96098 7.98176 7.96098 7.94114 7.95335C7.89527 7.94475 7.85154 7.92289 7.76409 7.87916L1.33594 4.66508Z",
    stroke: $props.color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1);
}